import React from 'react';
import {useRef, useState} from 'react';
import DdcForm from "./ThreeDSecure/DdcForm";
import CardDetails from './CardDetails';

export default function CreditCard({section, submitSection, billingAddress}) {
    const [isDdcComplete, setIsDdcComplete] = useState(false);

    const ddcFormRef = useRef(null);
    const ddcJwtInputRef = useRef(null);

    const submitDdcForm = (action, jwt) => {
        ddcJwtInputRef.current.value = jwt;
        ddcFormRef.current.action = action;
        ddcFormRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
        );
    }

    return <>
        <DdcForm
            formRef={ddcFormRef}
            jwtInputRef={ddcJwtInputRef}
            submitForm={submitDdcForm}
            setIsDdcComplete={setIsDdcComplete}
        />
        <CardDetails
            section={section}
            submitSection={submitSection}
            submitDdcForm={submitDdcForm}
            isDdcComplete={isDdcComplete}
            billingAddress={billingAddress}
        />
    </>;
}
